"use client";

import { createContext, useContext, useEffect, useState } from "react";
import api from "../utils/api";

export const AuthContext = createContext({});

const url = window.location.href;

export const AuthContextProvider = ({ children }) => {
    
    const [firstSteps, setFirstSteps] = useState([]);
    const [userInfos, setUserInfos] = useState([]);
    const [employeeInfos, setEmployeeInfos] = useState([]);
    const [userPaymentInfos, setUserPaymentInfos] = useState([]);
    const [userRoles, setUserRoles] = useState([]);
    const [userProfile, setUserProfile] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [costCenters, setCostCenters] = useState([]);
    const [favoriteCompany, setFavoriteCompany] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(typeof window !== "undefined" ? window.location.pathname : "");

    useEffect(() => {
        if (typeof window !== "undefined") {
            const handleUrlChange = () => {
                setCurrentPage(window.location.pathname);
            };

            window.addEventListener('popstate', handleUrlChange);

            return () => {
                window.removeEventListener('popstate', handleUrlChange);
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== "undefined" && !userInfos?.name) {

            let tokenInter = url.split('token')[1];
            let token = null;

            if(tokenInter){
    
                token = tokenInter.split('=')[1];
                localStorage.setItem('tokenStorage', token);
          
            }

            setIsLoading(true);

            api.get('/auth/me', {
                params: {
                    token: token || localStorage.getItem('tokenStorage')
                }
            })
            .then(function (res) {
                setEmployeeInfos(res.data.employee);
                setUserInfos(res.data.dados);
                setFirstSteps(res.data.first_steps);
                setUserPaymentInfos(res.data.payments);
                setUserRoles(res.data.roles);
                setUserProfile(res.data.profile);
                let favorite = null;
                if(res.data.empresas.length == 1){
                    favorite = res.data.empresas[0];
                }else{
                    for (let i = 0; i < res.data.empresas.length; i++) {
                        if (res.data.empresas[i].favorito === true) {
                            favorite = res.data.empresas[i];
                            break;
                        }
                    }          
                }  
                if(favorite){    
                    setFavoriteCompany(favorite);
                }
                setCompanies(res.data.empresas);
                let suppliersBd = [{
                    'label': '',
                    'value': ''
                }];
                res.data.suppliers.forEach(value => {
                    suppliersBd.push({
                        'label': value.name,
                        'value': value.id
                    });
                })
                setSuppliers(suppliersBd);
                setCostCenters(res.data.cost_centers);
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
            });
            
        }
    }, [userInfos?.name, currentPage, localStorage.getItem('tokenStorage')]);

    return(
        <AuthContext.Provider 
            value={{
                userInfos,
                setUserInfos,
                userPaymentInfos,
                setUserPaymentInfos,
                companies,
                setCompanies,
                isLoading,
                setIsLoading,
                userRoles,
                favoriteCompany,
                setFavoriteCompany,
                userProfile,
                firstSteps,
                suppliers,
                setSuppliers,
                employeeInfos,
                costCenters,
                setCostCenters
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export const useAuthContext = () => useContext(AuthContext);
